import { yup } from '@guiker/yup-util'

import { ChannelType } from '../../../../entity'

export const readAllNotificationsSchema = yup.object({
  channelType: yup.mixed<ChannelType>().oneOf(Object.values(ChannelType)).required(),
})
